import { apiClient } from "../utils/apiClient";
import { TypeNewsletter } from "../utils/constants";

export interface ITestNewsletterBody {
  operatorId: number;
  type: keyof typeof TypeNewsletter;
  email: string;
}

export const sendNewsletter = (body: ITestNewsletterBody, httpclient = apiClient) => {
  return httpclient.post("/api/v1/test-release-email-task", body);
};
